import { Component, OnInit } from "@angular/core";
import { CommonService } from "src/app/services/common.service";

@Component({
  selector: "app-short-courses",
  templateUrl: "./short-courses.component.html",
  styleUrls: ["./short-courses.component.css"],
})
export class ShortCoursesComponent implements OnInit {
  roleId: any;
  constructor(private CommonService: CommonService) {}

  async ngOnInit() {
    const decryptedValue: any = await this.CommonService.decryptAesGcm(
      localStorage.getItem("RoleId"),
      this.CommonService.key
    );
    this.roleId = +decryptedValue;
  }
}
